// SO过滤
const AddForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.sku', // SKU
            key:'sku',
            type:'select',   
            allowClear:true,
            width:'210px',
            placeholder:'base.select',
        },
        {
            name:'order.inventoryCode', // 物料编码
            key:'inventoryCode',
            type:'input',
            disabled:true,
            width:'210px',
            placeholder:'',
        },
    ]
}

// 订单来源查询
const OrderSourceQueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    showSlot:true,
    formData:{},
    formField:[
        {
            // name:'order.orderSource', // 订单来源
            key:'customer_name',
            type:'input',   
            allowClear:true,
            width:'180px',
            placeholder:'order.orderSource',
        },
        {
            // name:'order.orderSource', // 来源编码
            key:'customer_number',
            type:'input',   
            allowClear:true,
            width:'180px',
            placeholder:'order.customerNumber',
        },
        // {
        //     // name:'order.orderSource', // VAT号
        //     key:'vat_no',
        //     type:'input',   
        //     allowClear:true,
        //     width:'210px',
        //     placeholder:'config.vatNo',
        // },
        {
            // name:'order.orderSource', // 客户类型
            key:'type',
            type:'select',   
            allowClear:true,
            width:'150px',
            placeholder:'config.customerType',
            optionToLocale:true,
            options:[
                {
                    label:'order.user',
                    value:0,
                },
                {
                    label:'order.dealer',
                    value:1,
                }
            ]
        },
        {
            // name:'order.orderSource', // 区域
            key:'customer_class_code',
            type:'input',   
            allowClear:true,
            width:'180px',
            placeholder:'order.area',
        },
        {
            // name:'order.orderSource', // 客户等级
            key:'hf_customer_level',
            type:'input',   
            allowClear:true,
            width:'150px',
            placeholder:'order.hfCustomerLevel',
        },
        {
            // name:'order.orderSource', // 支付方式
            key:'payment_type',
            type:'input',   
            allowClear:true,
            width:'150px',
            placeholder:'order.paymentType',
        },
        {
            // name:'order.orderSource', // 状态
            key:'status',
            type:'select',   
            allowClear:true,
            width:'150px',
            placeholder:'config.status',
            optionToLocale:true,
            options:[
                {
                    value:'A',
                    label:'config.cooperate',
                },
                {
                    value:'I',
                    label:'config.invalid',
                }
            ]
        },
    ]
}

// 添加邮箱
const AddEmailForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'setting.email',
            key:'email',
            type:'input',
            width:'300px',
            placeholder:'base.input',
        },
    ]
}

// 查询-销售--经销商绑定关系
const QuerySaleDealerForm = {
    layout:'inline',
    labelColProps: { span: 5 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'180px',
    showSlot:false,
    formData:{},
    formField:[
        {
            // name:'config.saleName', // 销售
            key:'user_id',
            type:'select',
            allowClear:true,
            width:'400px',
            placeholder:'base.input',
            options:[]
        },
        {
            // name:'order.dealer', // 经销商
            key:'source_id',
            type:'select',
            allowClear:true,
            width:'400px',
            placeholder:'base.input',
            options:[]
        },
    ]
}

// 添加销售--经销商绑定关系
const AddSaleDealerForm = {
    // layout:'inline',
    labelColProps: { span: 5 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'180px',
    showSlot:false,
    formData:{},
    formField:[
        {
            name:'config.saleName', // 销售
            key:'user_id',
            type:'select',   
            required:true,
            allowClear:true,
            width:'400px',
            placeholder:'base.input',
            options:[]
        },
        {
            name:'order.dealer', // 经销商
            key:'source_id',
            type:'select',   
            required:true,
            allowClear:true,
            width:'400px',
            placeholder:'base.input',
            options:[]
        },
    ]
}

// 查询区域销售经理
const QueryAreaSaleManagerForm = {
    layout:'inline',
    labelColProps: { span: 5 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'180px',
    showSlot:false,
    formData:{},
    formField:[
        {
            // name:'config.saleName', // 销售经理
            key:'dict_sub_name',
            type:'input',
            allowClear:true,
            width:'400px',
            placeholder:'dealer.saleManager2',
        },
    ]
}

// 添加区域销售经理
const AddAreaSaleManagerForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 12 },
    labelAlign:'right',
    labelColStyle:'180px',
    showSlot:false,
    formData:{},
    formField:[
        {
            name:'dealer.saleManager', // 销售经理
            key:'dict_sub_name',
            type:'input',   
            required:true,
            allowClear:true,
            width:'400px',
            placeholder:'base.input',
        },
        {
            name:'base.email', // 销售经理邮箱
            key:'attribute1',
            type:'input',   
            required:true,
            allowClear:true,
            width:'400px',
            placeholder:'base.input',
        },
    ]
}

// 查询经销商发货日期区间
const QueryShipDateRangeForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    showSlot:false,
    formData:{},
    formField:[
        {
            // name:'order.orderSource', // 经销商
            key:'customer_id',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderSource',
            options:[]
        },
        {
            // name:'order.customerNumber', // 渠道来源编码
            key:'customer_number',
            type:'input',  
            allowClear:true,
            width:'200px',
            placeholder:'order.customerNumber',
        },
        {
            // name:'base.year', // 年
            key:'year',
            type:'select',  
            allowClear:true,
            width:'200px',
            placeholder:'base.year',
            options:[
                {
                    label:'2024',
                    value:'2024',
                },
                {
                    label:'2025',
                    value:'2025',
                },
                {
                    label:'2026',
                    value:'2026',
                }
            ]
        },
        {
            // name:'base.month', // 月
            key:'month',
            type:'select',  
            allowClear:true,
            width:'200px',
            placeholder:'base.month',
            options:[
                {
                    label:'1',
                    value:'1'
                },
                {
                    label:'2',
                    value:'2'
                },
                {
                    label:'3',
                    value:'3'
                },
                {
                    label:'4',
                    value:'4'
                },
                {
                    label:'5',
                    value:'5'
                },
                {
                    label:'6',
                    value:'6'
                },
                {
                    label:'7',
                    value:'7'
                },
                {
                    label:'8',
                    value:'8'
                },
                {
                    label:'9',
                    value:'9'
                },
                {
                    label:'10',
                    value:'10'
                },
                {
                    label:'11',
                    value:'11'
                },
                {
                    label:'12',
                    value:'12'
                }
            ]
        },
    ]
}

// 新建经销商发货日期区间
const AddShipDateRangeForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 12 },
    labelAlign:'right',
    labelColStyle:'180px',
    showSlot:false,
    formData:{},
    formField:[
        {
            name:'order.orderSource', // 经销商
            key:'customer_id',
            type:'select',   
            required:true,
            allowClear:true,
            width:'350px',
            placeholder:'base.select',
        },
        // {
        //     name:'config.dateRange', // 日期区间
        //     key:'date_range',
        //     type:'dateRange2',   
        //     required:true,
        //     allowClear:true,
        //     disabledDate:true,
        //     width:'350px',
        //     placeholder:'base.select',
        // },
        {
            name:'base.beginDate', // 开始日期
            key:'begin_date',
            type:'date2',   
            required:true,
            allowClear:true,
            disabled:false,
            showTime:false,
            disabledDate:true,
            width:'350px',
            placeholder:'base.beginDate',
        },
        {
            name:'base.endDate', // 结束日期
            key:'end_date',
            type:'date2',   
            required:true,
            allowClear:true,
            disabled:false,
            showTime:false,
            disabledDate:true,
            width:'350px',
            placeholder:'base.endDate',
        },
        {
            name:'config.reason', // 原因
            key:'reason',
            type:'textarea',
            allowClear:true,
            width:'350px',
            placeholder:'base.select',
        },
    ]
}

AddForm.formField.forEach(item=>{
    AddForm.formData[item.key] = ''
})

OrderSourceQueryForm.formField.forEach(item=>{
    OrderSourceQueryForm.formData[item.key] = ''
})

AddEmailForm.formField.forEach(item=>{
    AddEmailForm.formData[item.key] = ''
})

QuerySaleDealerForm.formField.forEach(item=>{
    QuerySaleDealerForm.formData[item.key] = ''
})

AddSaleDealerForm.formField.forEach(item=>{
    AddSaleDealerForm.formData[item.key] = ''
})

QueryAreaSaleManagerForm.formField.forEach(item=>{
    QueryAreaSaleManagerForm.formData[item.key] = ''
})

AddAreaSaleManagerForm.formField.forEach(item=>{
    AddAreaSaleManagerForm.formData[item.key] = ''
})

AddShipDateRangeForm.formField.forEach(item=>{
    AddShipDateRangeForm.formData[item.key] = ''
})

QueryShipDateRangeForm.formField.forEach(item=>{
    QueryShipDateRangeForm.formData[item.key] = ''
})


export {
    AddForm,
    OrderSourceQueryForm,
    AddEmailForm,
    QuerySaleDealerForm,
    AddSaleDealerForm,
    QueryAreaSaleManagerForm,
    AddAreaSaleManagerForm,
    AddShipDateRangeForm,
    QueryShipDateRangeForm,
}